import "./modal.scss";
import template from "./modal.html";
import {Options, Vue} from "vue-class-component";

@Options({
	template,
})
export class Modal extends Vue {
}
